var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ivu-ml-8",on:{"click":function($event){_vm.collapse = !_vm.collapse}}},[_vm._v(" "+_vm._s(_vm.collapse ? '收起' : '展开')+" "),_c('Icon',{attrs:{"type":`ios-arrow-${_vm.collapse ? 'up' : 'down'}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }